import { useTranslation } from "@sagot/i18n";
import { Badge, type BadgeTone } from "@sagot/ui";
import type { AgentStatus } from "./types";

const TONE: Readonly<Record<AgentStatus, BadgeTone>> = { live: "success", paused: "warning", draft: "neutral" };

/** Live / Paused / Draft: dot + text + tone (never colour alone). */
export function AgentStatusBadge({ status, className }: { status: AgentStatus; className?: string }) {
  const { t } = useTranslation();
  return (
    <Badge tone={TONE[status]} dot className={className} data-status={status}>
      {t(`build.status.${status}`)}
    </Badge>
  );
}
